<template lang="pug">
TabbedContainer
  TabItem(:name='name', :selected='true')
    slot
  TabItem(name='HTML' v-if="html")
    Prism(language="html" :code="html")
    button.button.is-tiny.is-white.is-code(@click="clip($event, html)") Copy
  TabItem(name='Pug' v-if="pug")
    Prism(language="pug" :code="pug")
    button.button.is-tiny.is-white.is-code(@click="clip($event, pug)") Copy
  TabItem(name='JavaScript' v-if="js")
    Prism(language="js" :code="js")
    button.button.is-tiny.is-white.is-code(@click="clip($event, js)") Copy


</template>

<script>
import TabbedContainer from '~/components/TabbedContainer';
import TabItem from '~/components/TabItem';
import Prism from '~/components/Prism';
import { copyToClipboard } from '~/utils/common';

export default {
  name: 'CodeSample',
  components: {
    TabbedContainer,
    TabItem,
    Prism
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    pug: {
      type: String,
      default: ''
    },
    html: {
      type: String,
      default: ''
    },
    js: {
      type: String,
      default: ''
    }
  },
  methods: {
    clip(e, snippet) {
      try {
        copyToClipboard(snippet);
        this.onCopy(e);
      } catch (err) {
        this.onError(err);
      }
    },
    onCopy(e) {
      e.target.innerHTML = 'Copied';
      setTimeout(() => {
        e.target.innerHTML = 'Copy';
      }, 3000);
    },
    onError(e, err) {
      e.target.innerHTML = 'Not Copied';
      setTimeout(() => {
        e.target.innerHTML = 'Copy';
      }, 3000);
      console.log(err);
    }
  }
};
</script>

<style lang="stylus">
code[class*='language-'], pre[class*='language-']
  color: #ccc
  background: none
  text-shadow: 0 1px rgba(0, 0, 0, 0.3)
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace
  text-align: left
  white-space: pre
  word-spacing: normal
  word-break: normal
  word-wrap: normal
  line-height: 1.5
  -webkit-hyphens: none
  -moz-hyphens: none
  -ms-hyphens: none
  hyphens: none

/* Code blocks */
pre[class*='language-']
  padding: unitRes(20, 40)
  overflow: auto
  border-radius: 0

:not(pre) > code[class*='language-'], pre[class*='language-']
  background: $clBlack

/* Inline code */
:not(pre) > code[class*='language-']
  padding: 0
  border-radius: 0
  white-space: normal

.token.comment, .token.prolog, .token.doctype, .token.cdata
  color: $clPurple

.token.punctuation
  color: #f8f8f2

.namespace
  opacity: 0.7

.token.property, .token.tag, .token.constant, .token.symbol, .token.deleted
  color: $clWarning

.token.boolean, .token.number
  color: $clPurple

.token.selector, .token.attr-name, .token.string, .token.char, .token.builtin, .token.inserted
  color: $clInfo

.token.operator, .token.entity, .token.url, .language-css .token.string, .style .token.string, .token.variable
  color: #f8f8f2

.token.atrule, .token.attr-value, .token.function
  color: $clPrimary

.token.keyword
  color: #66d9ef

.token.regex, .token.important
  color: $clWarning

.token.important, .token.bold
  font-weight: bold

.token.italic
  font-style: italic

.token.entity
  cursor: help
</style>
